// src/store/flightCartSlice.ts
import { createSlice, PayloadAction } from "@reduxjs/toolkit";

interface FlightCartState {
  selectedFlight: any;
  total: number;
}

const initialState: FlightCartState = {
  selectedFlight: null,
  total: 0,
};

const flightCartSlice = createSlice({
  name: "flightCart",
  initialState,
  reducers: {
    setSelectedFlight(state, action: PayloadAction<any>) {
      state.selectedFlight = action.payload;
      const basePrice = Number(action.payload.price || 0);
      const passengers = Number(action.payload.passengers || 1);
      state.total =
        action.payload.tripType === "Two Way"
          ? basePrice * passengers * 2
          : basePrice * passengers;
    },
    clearFlightCart(state) {
      state.selectedFlight = null;
      state.total = 0;
    },
  },
});

export const { setSelectedFlight, clearFlightCart } = flightCartSlice.actions;
export default flightCartSlice.reducer;
